import Router from 'vue-router'
import guards from './guards'
import comprador from './routes/comprador'
import comum from './routes/comum'
import fornecedor from './routes/fornecedor'
import store from '@/core/store'

const index = new Router({
    routes: [
        {
            path: '/',
            name: 'Inicial',
            redirect: () => {
                if (store.state.loki.user.type === 'EXTERNO') {
                    return {name: 'ComprasDiretasAbertas'}
                } else {
                    return {name: 'TodasComprasDiretas'}
                }
            }
        },
        ...comprador,
        ...fornecedor,
        ...comum
    ],
    scrollBehavior (to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition
        } else {
            let position = {}
            if (to.hash) {
                return {
                    selector: to.hash
                }
            }
            if (to.matched.some(m => m.meta.scrollToTop)) {
                position.x = 0
                position.y = 0
            }
            return position
        }
    }
})

index.beforeEach((to, from, next) => guards.conditions(to, from, next))

export default index
